<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Información de la Atributo</h1>
    <div class="information" v-if="attr">
      <p class="information__text"><strong class="information__text--strong">Nombre (ES): </strong>{{attr.name_es}}</p>
      <p class="information__text"><strong class="information__text--strong">Nombre (EN): </strong>{{attr.name_en}}</p>
      <p v-if="attr.code_es" class="information__text"><strong class="information__text--strong">Código (ES): </strong>{{attr.code_es}}</p>
      <p v-if="attr.code_en" class="information__text"><strong class="information__text--strong">Código (EN): </strong>{{attr.code_en}}</p>
      <p v-if="attr.type_id" class="information__text"><strong class="information__text--strong">Tipo: </strong>{{attr.attr_type_name}}</p>
      <p v-if="attr.icon" class="information__text"><strong class="information__text--strong">Icono del atributo:</strong></p>
      <img v-if="attr.icon" :src="icon" :alt="attr.name" class="information__image information__image--wide">
    </div>
  </div>
</template>

<script>
import {nl2br} from '@/core/libs/functions'
import {config} from '@/core/config/base'
export default {
  props: {
    attr: {
      type: Object
    }
  },
  computed: {
    icon: function () {
      let img = ''
      if (this.attr.icon) {
        img = config.statics.url + JSON.parse(this.attr.icon).sizes.small
      }
      return img
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/attributes/view.vue